<template>
    <div>
        <div class="menu-background" v-if="isModalOpen" @click.self="closeMenuModal"></div>
        <transition name="slide-from-left">
            <div class="menu-modal" v-if="isModalOpen">
                <div class="grid-container">
                    <div class="grid-x align-justify">
                        <div class="menu-modal-close-button show-for-large">
                            <a @click="closeMenuModal" v-html="Icon.MODAL_CLOSE" class="color-dark-gray"></a>
                        </div>
                        <div class="cell menu-header-mobile">
                            <div class="grid-x grid-margin-x align-middle">
                                <div class="cell auto logo-container">
                                    <img :src="storeLogo" alt="Store Logo">
                                </div>
                                <div class="cell shrink schedule">
                                    <p class="display-small bold menu-title margin-0">Store openings</p>
                                    <p v-for="(label, i) in storeOpenings" :key="i" class="margin-0">
                                        {{ label }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="cell menu-content account">
                            <div class="align-middle grid-x grid-margin-x">
                                <div class="cell auto">
                                    <p class="display-small bold menu-title text-uppercase margin-0">Your Account</p>
                                    <p class="display-large semi-bold menu-color margin-0" v-if="currentUser">{{ currentUser.name }}</p>
                                </div>
                                <div class="cell shrink">
                                    <a v-if="currentUser" @click.prevent="logout" class="align-middle account-button flex-container semi-bold"><i class="account-icon" v-html="Icon.LOGOUT"></i><span>Logout</span></a>
                                    <a v-else @click.prevent="login" class="align-middle account-button flex-container semi-bold"><i class="account-icon" v-html="Icon.LOGOUT"></i><span>Sign in or register</span></a>
                                </div>
                            </div>
                        </div>
                        <div class="cell menu-content">
                            <div class="grid-x grid-padding-x links-container">
                                <div v-if="sidebarLink" class="cell shrink link-container">
                                    <a target="_blank" :href="sidebarLink.link" class="display-large semi-bold menu-color">{{ sidebarLink.label }}</a>
                                </div>
                                <div v-if="sidebarLink2" class="cell shrink link-container">
                                    <a target="_blank" :href="sidebarLink2.link" class="display-large semi-bold menu-color">{{ sidebarLink2.label }}</a>
                                </div>
                                <div class="cell shrink link-container">
                                    <a @click="closeAndGo('contact')" class="display-large semi-bold menu-color">Contact Us</a>
                                </div>
                                <div class="cell shrink link-container" v-if="!isIOS">
                                    <a @click="installPWA" class="display-large semi-bold menu-color">Install app</a>
                                </div>
                                <div class="cell shrink link-container">
                                    <a @click="closeAndGo('terms')" class="display-large semi-bold menu-color">Terms of Use</a>
                                </div>
                                <div class="cell shrink link-container">
                                    <a @click="closeAndGo('privacy')" class="display-large semi-bold menu-color">Privacy Policy</a>
                                </div>
                                <div class="cell shrink link-container">
                                    <a @click="closeAndGo('cookie')" class="display-large semi-bold menu-color">Cookie Policy</a>
                                </div>
                                <div class="cell shrink link-container credit">
                                    <div class="grid-x align-justify">
                                        <div class="cell shrink">
                                            <span class="light copyright">&copy; {{ year }} {{ storeName }}</span>
                                        </div>
                                        <div class="cell shrink">
                                            <ul class="align-middle socials-list flex-container">
                                                <li v-if="storeFacebook" style="margin-right:17px"><a :href="storeFacebook" target="_blank" v-html="Icon.FACEBOOK"></a></li>
                                                <li v-if="storeTwitter" style="margin-right:10px"><a :href="storeTwitter" target="_blank" v-html="Icon.TWITTER"></a></li>
                                                <li v-if="storeInstagram"><a :href="storeInstagram" target="_blank" v-html="Icon.INSTAGRAM"></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="grid-x grid-margin-x">
                                    <div class="cell auto large-shrink">
                                        <a class="semi-bold contact-button" :href="'tel:' + storePhone">Call us</a>
                                        <!-- <span class="show-for-large">{{ storePhone }}</span> -->
                                    </div>
                                    <div class="cell auto">
                                        <a class="semi-bold contact-button" :href="storeLocationLink">Get directions</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>

</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component';

import { getModule } from 'vuex-module-decorators';
import FoodModule from '@/stores/modules/food';
import { Icon } from '@/front/icons';
import Settings, { SettingNamespace } from '@/utils/settings';
import UserModule from '@/stores/modules/user';
import { isIOS } from '@/utils/utilities';
type SidebarLink = {
    label: string;
    link: string;
};

@Component({
    components: {  }
})

export default class MenuModal extends Vue
{
    foodModule!: FoodModule;
    userModule!: UserModule;
    storeName: string = '';
    storeOpenings: string = '';
    storeLogo: string = '';
    storePhone: string = '';
    storeLocationLink: string = '';
    storeFacebook: string = '';
    storeInstagram: string = '';
    storeTwitter: string = '';
    sidebarLink: SidebarLink | null = null;
    sidebarLink2: SidebarLink | null = null;

    async created() {
        this.foodModule = getModule(FoodModule, this.$store);
        this.userModule = getModule(UserModule, this.$store);

        const settings = await Settings.getInstance();

        this.storeName = settings.get(SettingNamespace.GENERAL, 'store_name')?.value;
        this.storeOpenings = settings.get(SettingNamespace.OPENINGS, 'store_openings')?.value.split('|');
        this.storeLogo = settings.get(SettingNamespace.GENERAL, 'store_logo')?.value;
        this.storeFacebook = settings.get(SettingNamespace.GENERAL, 'store_facebook')?.value;
        this.storeInstagram = settings.get(SettingNamespace.GENERAL, 'store_instagram')?.value;
        this.storeTwitter = settings.get(SettingNamespace.GENERAL, 'store_twitter')?.value;
        this.storePhone = settings.get(SettingNamespace.CONTENT, 'contact_phone')?.value;
        this.storeLocationLink = settings.get(SettingNamespace.GENERAL, 'store_location_link')?.value;
        this.sidebarLink = settings.get(SettingNamespace.CONTENT, 'sidebar_link')?.value;
        this.sidebarLink2 = settings.get(SettingNamespace.CONTENT, 'sidebar_link_2')?.value;


    }

    mounted() {
        this.$watch(() => this.isModalOpen, (value) => {
            if (value === true) {
                document.addEventListener('keydown', this.handleKeydown);
            } else {
                document.removeEventListener('keydown', this.handleKeydown);
            }
        });
    }

    handleKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            this.closeMenuModal();
        }
    }

    async installPWA() {
        let installEvent = (<any>window).beforeinstallpromptEvent;
        if (installEvent) {
            (<any>installEvent).prompt();
            const { outcome } = await (<any>installEvent).userChoice;
            if ((<any>window).gtag !== undefined && (<any>window).gaMeasurementId !== undefined) {
                (<any>window).gtag(
                    'event', (outcome === 'accepted') ? 'installed_app' : 'dismissed_install', {
                    'event_category': 'pwa',
                    'event_label': 'App installation'
                });
            }
        }
    }

    closeMenuModal() {
        this.foodModule.closeMenuModal();
    }

    closeAndGo(routeName: string) {
        this.foodModule.closeMenuModal();
        this.$router.push({name: routeName})
    }

    login() {
        this.foodModule.closeMenuModal();
        this.userModule.openLoginModal();
    }

    logout() {
        this.userModule.logout();
    }

    get isIOS() {
        return isIOS();
    }

    get currentUser() {
        return this.userModule.currentUser;
    }

    get year() {
        return new Date().getFullYear();
    }

    get isModalOpen() {
        return this.foodModule.menuModalOpen;
    }

    get Icon() {
        return Icon;
    }
}
</script>
<style lang="scss">
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.menu-modal {
    @include breakpoint(medium down) {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 75px;
        overflow-y: auto;
        display: flex;
        background: var(--side-menu-bg);
        padding: 28px 10px;
        z-index: 11;
    }
    @include breakpoint(large) {
        background-color: var(--side-menu-bg);
        height: 100vh;
        overflow-y: auto;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        width: var(--side-menu-width);
        padding: 30px 15px;
        box-shadow: 5px 5px 40px 0 rgba(0, 0, 0, 0.09);
        z-index: 20;
    }

    .menu-color {
        color: var(--side-menu-color);
    }

    .menu-title, .copyright {
        color: rgba(255, 255, 255, 0.8);
    }

    .logo-container {
        img {
            width: 180px;
        }
    }

    .menu-modal-close-button {
        @include breakpoint(large) {
            width: 20px;
            height: 20px;
            margin-bottom: 50px;
        }

        path {
            fill: var(--side-menu-cross-color);
        }
    }

    .links-container {
        flex-direction: column;
    }

    .link-container {
        @include breakpoint(medium down) {
            padding: 10px 0px;
        }
        @include breakpoint(large) {
            padding: 15px 0px;
        }
    }

    .menu-header-mobile {
        padding-bottom: 25px;
    }

    .schedule {
        text-align: right;
        text-transform: uppercase;
        letter-spacing: 1px;
        font-weight: 600;
        color: var(--side-menu-color);
    }

    .account-button {
        color: var(--side-menu-color);
        padding: var(--button-padding);
        border-radius: var(--button-radius);
        background: var(--side-menu-button-bg);

        .account-icon {
            display: inline-block;
            height: 18px;
            padding-right: 5px;

            path {
                fill: var(--side-menu-color);
            }
        }
    }

    .contact-button {
        display: block;
        text-align: center;
        padding: 15px;
        border-radius: var(--button-radius);
        color: var(--side-menu-contact-color);
        background: var(--side-menu-contact-bg);
        width: 100%;
        @media screen and (max-width: 320px) {
            padding: 9px;
        }
    }

    .menu-content {
        padding: 15px 0px;
        border-top: rgba(white, 0.1) solid 1px;

        .credit {
            padding-top: 15px;
            margin-top: 10px;
            border-top: rgba(white, 0.1) solid 1px;

            .copyright {
                padding-bottom: 10px;
                display: block;
            }
            a {
                color: var(--battleship-gray);
            }
        }

    }

    .socials-list {
        margin: 0;
        list-style-type: none;
        li {
            display: inline-block;
            :not(:last-child) {
                margin-right: 22px;
            }
        }
    }
    .credit-container-mobile {
        @include breakpoint(medium down) {
            margin-top: 40px;
        }
    }

}
.menu-background {
    @include breakpoint(large) {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 3;
        overflow: scroll;
        background: transparent;
    }
}
</style>

